"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
const three_1 = require("three");
const types_1 = require("~/store/types");
const _1 = require(".");
const consts_1 = require("../consts");
const classes_1 = require("../classes");
const utils_3d_1 = require("./utils.3d");
const GasketInSlotSnapping_1 = __importDefault(require("../classes/SlotCoverSnapping/GasketInSlotSnapping"));
const Viewer_1 = __importDefault(require("../Viewer"));
class ConnectionObject extends three_1.Object3D {
    constructor(connection, mainObject, connectedObject) {
        super();
        this.areFastenersInSelectedState = false;
        this.isSphereInSelectedState = false;
        this.type = 'Connection';
        this.bindConnection(connection);
        this.mainObject = mainObject;
        this.connectedObject = connectedObject;
        this.setAddFastenersCallback((objects) => {
            if (objects.length) {
                this.add(...objects);
            }
        });
        this.setRemoveFastenersCallback((objects) => {
            if (objects.length) {
                this.remove(...objects);
            }
        });
        this.setTransformFastenersCallback(() => {
            /* Do nothing */
        });
    }
    setAddFastenersCallback(callback) {
        this.addFastenersCallback = callback;
    }
    setRemoveFastenersCallback(callback) {
        this.removeFastenersCallback = callback;
    }
    setTransformFastenersCallback(callback) {
        this.transformFastenersCallback = callback;
    }
    getConnection() {
        return this.connection;
    }
    getMainObject() {
        return this.mainObject;
    }
    getConnectedObject() {
        return this.connectedObject;
    }
    getConnectionItems() {
        let mainItem = null;
        let connectedItem = null;
        this.connection.items.forEach((item) => {
            if (item.isMain) {
                mainItem = item;
            }
            else {
                connectedItem = item;
            }
        });
        return { mainItem, connectedItem };
    }
    getConnectionClone() {
        return JSON.parse(JSON.stringify(this.getConnection()));
    }
    bindConnection(connection) {
        this.connection = connection;
        if (this.connection.connectionUuid === '') {
            this.connection.connectionUuid = this.uuid;
        }
        else {
            this.uuid = this.connection.connectionUuid;
        }
    }
    removeFromParent() {
        this.removeFasteners();
        return super.removeFromParent();
    }
    addFasteners(fasteners, useGroupBoxes = true, useCollision = true) {
        this.bindFasteners(fasteners);
        this.addFastenersCallback(fasteners, this, useGroupBoxes, useCollision);
        return this.onAfterAddOrShowFasteners(fasteners[0]);
    }
    onAfterAddOrShowFasteners(fastener) {
        var _a;
        const mainObject = this.getMainObject();
        const connectedObject = this.getConnectedObject();
        if ((fastener === null || fastener === void 0 ? void 0 : fastener.fastenerType) === types_1.FASTENER_TYPES.PLATE_CONNECTOR) {
            const result = _1.ConnectionUtils.onAfterAddOrShowPlateConnector(fastener, connectedObject, mainObject);
            this.updateItemSize();
            return result;
        }
        if (((_a = fastener === null || fastener === void 0 ? void 0 : fastener.partDetails) === null || _a === void 0 ? void 0 : _a.componentType) === 'Panel gasket') {
            const gasketSnapping = new GasketInSlotSnapping_1.default(Viewer_1.default.instance, fastener);
            gasketSnapping.fixPanelPosition(mainObject);
        }
        return false;
    }
    addSphere(sphere) {
        this.add(sphere);
    }
    removeFasteners(fasteners) {
        const fastenersToRemove = fasteners !== null && fasteners !== void 0 ? fasteners : this.getFasteners();
        const result = fastenersToRemove.some((fastener) => !fastener.visible)
            ? false
            : this.onBeforeRemoveOrHideFasteners(fastenersToRemove[0]);
        this.unbindFasteners(fastenersToRemove);
        this.removeFastenersCallback(fastenersToRemove);
        return result;
    }
    onBeforeRemoveOrHideFasteners(fastener) {
        var _a;
        const mainObject = this.getMainObject();
        const connectedObject = this.getConnectedObject();
        if ((fastener === null || fastener === void 0 ? void 0 : fastener.fastenerType) === types_1.FASTENER_TYPES.PLATE_CONNECTOR) {
            const result = _1.ConnectionUtils.onBeforeRemoveOrHidePlateConnector(fastener, connectedObject, mainObject);
            this.updateItemSize();
            return result;
        }
        if (((_a = fastener === null || fastener === void 0 ? void 0 : fastener.partDetails) === null || _a === void 0 ? void 0 : _a.componentType) === 'Panel gasket') {
            const gasketSnapping = new GasketInSlotSnapping_1.default(Viewer_1.default.instance, fastener);
            gasketSnapping.fixPanelPosition(mainObject, true);
        }
        return false;
    }
    removeSphere() {
        const sphere = this.getSphere();
        if (sphere) {
            this.remove(sphere);
        }
    }
    getFastenerCount() {
        return this.children.length;
    }
    getSphere() {
        return this.children.find((child) => child.type === 'Mesh');
    }
    updateSphereRadius(radius) {
        const sphere = this.getSphere();
        if (!sphere) {
            return;
        }
        const { geometry, material } = _1.ConnectionUtils.createConnectionSphere(radius, sphere.position);
        Object.assign(sphere, { geometry, material });
    }
    getFasteners() {
        return this.children.filter((child) => _1.Utils.isFastener(child));
    }
    getFastenersMetadata() {
        return this.children
            .filter((child) => child instanceof classes_1.BaseObject3D && (0, utils_3d_1.isFastener)(child))
            .map((child) => {
            var _a;
            const { position, quaternion, partDetails, slotNumber, distanceToTheEdge } = child;
            const panelSize = _1.Utils.getFastenerSize(child);
            return {
                itemNumber: partDetails.itemNumber,
                size: (_a = child.getLength()) !== null && _a !== void 0 ? _a : 0,
                panelSize,
                position,
                rotation: {
                    x: quaternion.x,
                    y: quaternion.y,
                    z: quaternion.z,
                    w: quaternion.w,
                },
                slotNumber,
                distanceToTheEdge,
            };
        });
    }
    setFastenersVisualState(state) {
        this.getFasteners().forEach((fastener) => fastener.setVisualState && fastener.setVisualState(state));
    }
    selectFasteners() {
        if (this.areFastenersSelected()) {
            return;
        }
        this.showSelectionBox(consts_1.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
        this.areFastenersInSelectedState = true;
    }
    unselectFasteners() {
        if (!this.areFastenersSelected()) {
            return;
        }
        this.showSelectionBox();
        this.areFastenersInSelectedState = false;
    }
    selectSphere() {
        if (this.isSphereSelected()) {
            return;
        }
        this.updateSphereRadius(consts_1.consts.INCREASED_CONNECTION_SPHERE_RADIUS);
        this.isSphereInSelectedState = true;
    }
    unselectSphere() {
        if (!this.isSphereSelected()) {
            return;
        }
        this.updateSphereRadius(consts_1.consts.DEFAULT_CONNECTION_SPHERE_RADIUS);
        this.isSphereInSelectedState = false;
    }
    areFastenersSelected() {
        return this.areFastenersInSelectedState;
    }
    isSphereSelected() {
        return this.isSphereInSelectedState;
    }
    makeSphereVisible() {
        const sphere = this.getSphere();
        if (!sphere) {
            return;
        }
        sphere.visible = true;
    }
    makeSphereInvisible() {
        const sphere = this.getSphere();
        if (!sphere) {
            return;
        }
        sphere.visible = false;
    }
    showSelectionBox(rgbColor = consts_1.consts.SELECTION_BOX_COLOR_VECTOR) {
        this.getFasteners().forEach((fastener) => {
            fastener.showSelectionBox(rgbColor);
        });
    }
    hideSelectionBox() {
        this.getFasteners().forEach((fastener) => {
            fastener.hideSelectionBox();
        });
    }
    showFasteners() {
        if (this.getFasteners().every((fastener) => fastener.visible)) {
            return;
        }
        this.getFasteners().forEach((fastener) => {
            fastener.visible = true;
        });
        this.onAfterAddOrShowFasteners(this.getFasteners()[0]);
    }
    showConnection() {
        if (this.getFastenerCount()) {
            this.showFasteners();
        }
        else {
            this.makeSphereVisible();
        }
    }
    hideFasteners() {
        if (this.getFasteners().every((fastener) => !fastener.visible)) {
            return;
        }
        this.onBeforeRemoveOrHideFasteners(this.getFasteners()[0]);
        this.getFasteners().forEach((fastener) => {
            fastener.visible = false;
        });
    }
    hideConnection() {
        if (this.getFastenerCount()) {
            this.hideFasteners();
        }
        else {
            this.makeSphereInvisible();
        }
    }
    transformFastenersAndSphere(transformation) {
        this.children.forEach((child) => {
            child.applyMatrix4(transformation);
        });
        this.transformFastenersCallback(this.getFasteners());
    }
    bindFasteners(fasteners) {
        if (!this.connection.items.length) {
            return;
        }
        fasteners.forEach((fastener) => {
            fastener.addConnectionItems(...this.connection.items);
        });
    }
    unbindFasteners(fasteners) {
        if (!this.connection.items.length) {
            return;
        }
        fasteners.forEach((fastener) => {
            fastener.removeConnectionItems(...this.connection.items.map((item) => item.uuid));
        });
    }
    updateItemSize() {
        var _a, _b;
        const { mainObject } = this;
        const mainItem = this.connection.items.find((item) => item.isMain);
        if (mainItem) {
            mainItem.geomkernelPosition = mainObject.position;
            mainItem.position = (_a = mainObject.originalPosition) !== null && _a !== void 0 ? _a : mainObject.position;
            mainItem.geomkernelPanelSize = mainObject.getSize();
            mainItem.panelSize = (_b = mainObject.originalPanelSize) !== null && _b !== void 0 ? _b : mainObject.getSize();
            mainItem.size = mainObject.getLength();
        }
    }
    get isPanelToExtrusionSideConnection() {
        return this.connection.connectionType === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SIDE;
    }
    get isComponentConnection() {
        return this.connection.connectionType === types_1.CONNECTION_TYPE.COMPONENT;
    }
}
exports.default = ConnectionObject;
